import LeftNav, { LeftNavProps } from './LeftNav';

import withPresenter from './LeftNav.presenter';
import withInteractor from './LeftNav.interactor';

const LeftNavOrganisms = withInteractor(withPresenter(LeftNav));

export type { LeftNavProps };
export default LeftNavOrganisms;
